import React from 'react';
import { Link } from 'react-router-dom';

import { PageContent } from '@digiwedge/tee-time-ui';

export const NotFoundPage: React.FC = () => (
  <PageContent className="px-4 py-16">
    <div className="mx-auto max-w-xl text-center">
      <p className="text-sm font-semibold uppercase tracking-wide text-primary">404</p>
      <h1 className="mt-3 text-3xl font-semibold text-gray-950">Page not found</h1>
      <p className="mt-3 text-gray-600">
        This TeeTime page does not exist, or the link is no longer valid.
      </p>
      <div className="mt-8 flex flex-col justify-center gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex h-10 items-center justify-center rounded-md bg-primary px-5 text-sm font-semibold text-white"
        >
          Go home
        </Link>
        <Link
          to="/search"
          className="inline-flex h-10 items-center justify-center rounded-md border border-gray-300 px-5 text-sm font-semibold text-gray-800"
        >
          Search tee times
        </Link>
      </div>
    </div>
  </PageContent>
);
